<template>
  <div>
    <Row class="search-con">
      <Col>
        <Button @click="backHistory" class="search-btn">返回</Button>
      </Col>
    </Row>
    <Card class="info-detail">
      <h3>染缸详情</h3>
      <Row>
        <Col><br /></Col>
        <Col span="6"
          ><b>染缸编号:</b>
          <label style="font-size: 16px"> {{ batchInfo.batch_no }}</label></Col
        >
        <Col span="6"
          ><b>品名:</b>
          <label style="font-size: 16px">
            {{ batchInfo.cloth_type }}</label
          ></Col
        >
        <Col span="6"
          ><b>布匹颜色:</b>
          <label style="font-size: 16px">
            {{ batchInfo.cloth_color }}</label
          ></Col
        >
        <Col span="6"
          ><b>总要求码长:</b>
          <label style="font-size: 16px">
            {{ allStandLength }}</label
          ></Col
        >
      </Row>
      <Row>
        <Col><br /></Col>
      </Row>
      <Row>
        <Col span="6"
          ><b>订单编号:</b>
          <label style="font-size: 16px"> {{ batchInfo.orderNo }}</label></Col
        >
        <Col span="6"
          ><b>金额:</b>
          <label style="font-size: 16px"> {{ batchInfo.money }}</label></Col
        >
        <Col span="6"
          ><b>匹数:</b>
          <label style="font-size: 16px">
            {{ batchInfo.piece_count }}</label
          ></Col
        >
        <Col span="6"
          ><b>总测量码长:</b>
          <label style="font-size: 16px">
            {{ allLength }}</label
          ></Col
        >
      </Row>
    </Card>
    <Card>
      <Row class="search-con">
        <Col span="20">
          <Input
            clearable
            placeholder="输入关键字搜索"
            class="search-input"
            v-model="searchValue"
          />
          <Button @click="handleSearch" class="search-btn" type="primary"
            >搜索</Button
          >
        </Col>
      </Row>
      <Row class="search-con">
        <Col class="search-right">
          <Button @click="deletePieces" type="primary" class="search-btn">
            批量删除布匹
          </Button>
          <Button @click="downloadReport" type="primary" class="search-btn"
            >批量下载报告</Button
          >
          <Button @click="downloadExcelReport" type="primary" class="search-btn"
            >导出excel报告</Button
          >
          <!-- <Button
            @click="downloadShipMent('shipment')"
            type="primary"
            class="search-btn"
            >导出出货单</Button
          >
          <Button
            @click="downloadShipMent('settlement')"
            type="primary"
            class="search-btn"
            >导出结算单</Button
          > -->
          <Button @click="showAddModal" type="primary" class="search-btn"
            >添加</Button
          >
        </Col>
      </Row>
      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
        @on-selection-change="changeId"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            show-sizer
            show-elevator
            :page-size-opts="[10, 20, 50, 999]"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>
    <Modal
      :width="modalWidth"
      :mask-closable="false"
      v-model="addModal"
      title="添加染缸"
      footer-hide
    >
      <forms
        :resetFlag="resetFlag"
        ref="addChild"
        @on-ok="addSumit"
        @on-cancel="cancel"
      />
    </Modal>
    <Modal
      :width="modalWidth"
      :mask-closable="false"
      v-model="editModal"
      title="编辑染缸"
      footer-hide
    >
      <forms
        :resetFlag="resetFlag"
        ref="editChild"
        :editData="editData"
        @on-ok="editSumit"
        @on-cancel="cancel"
      />
    </Modal>
  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";
import Forms from "./piece-form.vue";
import axios from "axios";
import JSZip from "jszip";
import FileSaver from "file-saver";
import {
  getPieceList,
  getPieceInfo,
  addPiece,
  delPiece,
  editPiece,
  getOrderInfo,
  editBatchMoney,
  getBatchInfo,
  downloadQr,
  getPieceShipment,
  getPieceReport,
  delPieces,
} from "@/api/data";
export default {
  name: "piece",
  components: {
    Tables,
    Forms,
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,

      allStandLength: 0,
      allLength: 0,
      modalWidth: 600,
      addModal: false,
      editModal: false,
      resetFlag: false,
      editData: {},
      searchValue: "",
      batchId: 0,
      batchInfo: {},
      edittingCellId: "",
      edittingText: "",
      selectId: [],
      reportUrlList: [],
      statusList: [
        { id: 0, name: "初创建" },
        { id: 1, name: "入库中" },
        { id: 2, name: "检测中" },
        { id: 3, name: "检测完成" },
        { id: 4, name: "检测完成" },
        { id: 5, name: "付款完成" },
        { id: 6, name: "已取消" },
      ],
      status: "",
      tableLoading: true,
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
          fixed: "left",
        },
        {
          title: "匹号",
          key: "piece_no",
          fixed: "left",
          width: 150,
          editable: true,
        },
        {
          title: "客户匹号",
          key: "customer_piece_no",
          width: 150,
          editable: true,
        },
        {
          title: "要求码长",
          key: "stand_length_code",
          width: 120,
          editable: true,
        },
        { title: "机测码长", key: "length", width: 100, editable: true },
        { title: "要求幅宽", key: "stand_width", width: 120, editable: true },
        { title: "机测幅宽", key: "width", width: 100, editable: true },
        { title: "瑕疵数", key: "flaw_count", width: 100, editable: true },
        { title: "检测员", key: "check_username", width: 120, editable: true },
        {
          title: "百码扣分",
          key: "hundred_deduct",
          width: 100,
          editable: true,
        },
        { title: "检测设备", key: "device_no", width: 120, editable: true },
        {
          title: "客户机器编号",
          key: "customer_machine",
          width: 120,
          editable: true,
        },
        { title: "重量(kg)", key: "weight", width: 100, editable: true },
        {
          title: "状态",
          key: "status",
          render: (h, params) => {
            let texts = "";
            if (params.row.status == 0) {
              texts = "初创建";
            } else if (params.row.status == 1) {
              texts = "入库完成";
            } else if (params.row.status == 2) {
              texts = "检测中";
            } else if (params.row.status == 3) {
              texts = "检测完成";
            } else if (params.row.status == 4) {
              texts = "出库完成";
            }
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          },
          width: 90,
          editable: true,
        },
        {
          title: "开始检测时间",
          key: "start_check_time",
          width: 150,
          editable: true,
        },
        {
          title: "检测完成时间",
          key: "end_check_time",
          width: 150,
          editable: true,
        },
        {
          title: "Handle",
          key: "handle",
          width: 100,
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Dropdown",
                {
                  props: {
                    transfer: true,
                  },
                },
                [
                  h(
                    "Button",
                    {
                      props: {
                        type: "text",
                        size: "small",
                      },
                    },
                    "操作"
                  ),
                  h(
                    "DropdownMenu",
                    {
                      slot: "list",
                    },
                    [
                      h(
                        "DropdownItem",
                        {
                          nativeOn: {
                            click: (name) => {
                              this.viewReport(params);
                            },
                          },
                        },
                        "查看验布报告"
                      ),
                      h(
                        "DropdownItem",
                        {
                          nativeOn: {
                            click: (name) => {
                              this.downloadLink(params);
                            },
                          },
                        },
                        "下载布匹二维码"
                      ),
                      h(
                        "DropdownItem",
                        {
                          nativeOn: {
                            click: (name) => {
                              this.showEditModal(params);
                            },
                          },
                        },
                        "编辑"
                      ),
                      h(
                        "DropdownItem",
                        {
                          nativeOn: {
                            click: (name) => {
                              this.handleDelete(params);
                            },
                          },
                        },
                        "删除"
                      ),
                    ]
                  ),
                ]
              ),
            ]);
          },
        },
      ],
      tableData: [],
    };
  },
  methods: {
    changeId(selection) {
      this.selectId = [];
      this.reportUrlList = [];
      let allLength = 0
      let allStandLength = 0
      for (let i = 0; i < selection.length; i++) {
        this.selectId[i] = selection[i].id;
        this.reportUrlList[i] = selection[i].url;
        allStandLength += selection[i].stand_length_code
        allLength += selection[i].length
      }
      this.allStandLength = allStandLength
      this.allLength = allLength
    },
    getFile(url) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url,
          responseType: "arraybuffer",
        })
          .then((data) => {
            resolve(data.data);
          })
          .catch((error) => {
            reject(error.toString());
          });
      });
    },
    downloadReport() {
      const zip = new JSZip();
      const promises = [];
      this.reportUrlList.forEach((url, index) => {
        const promise = this.getFile(url).then((data) => {
          let fileName = url.substr(url.lastIndexOf("/") + 1);
          zip.file(fileName, data, { binary: true });
        });
        promises.push(promise);
      });
      Promise.all(promises).then(() => {
        zip
          .generateAsync({ type: "blob" })
          .then((content) => {
            FileSaver.saveAs(content, new Date().getTime());
          })
          .catch((err) => {
            this.$Message.error(err || "压缩文件失败");
          });
      });
    },
    downloadShipMent(type) {
      if (this.selectId.length == 0) {
        this.$Message.warning("请选择布匹");
        return;
      }
      getPieceShipment(this.selectId, type).then((res) => {
        if (res.data.code == 200) {
          window.setTimeout(function () {
            if (process.env.NODE_ENV === "production") {
              window.open("https://bu.sinano-ai.com/" + res.data.data);
            } else {
              window.open(
                "http://192.168.1.167:8080/api/static/" + res.data.data
              );
            }
          }, 2000);
        }
      });
    },
    downloadExcelReport() {
      if (this.selectId.length == 0) {
        this.$Message.warning("请选择布匹");
        return;
      }
      getPieceReport(this.selectId).then((res) => {
        if (res.data.code == 200) {
          window.setTimeout(function () {
            if (process.env.NODE_ENV === "production") {
              window.open("https://bu.sinano-ai.com/" + res.data.data);
            } else {
              window.open(
                "http://192.168.1.167:8080/api/static/" + res.data.data
              );
            }
          }, 2000);
        }
      });
    },
    backHistory() {
      this.$router.go(-1);
    },
    getBatchDetail() {
      getBatchInfo(this.batchId).then((res) => {
        if (res.data.code == 200) {
          this.batchInfo = res.data.data;
        }
      });
    },
    showAddModal() {
      var data = {};
      getBatchInfo(this.batchId).then((res) => {
        if (res.data.code == 200) {
          data = { id: this.batchId, no: res.data.data.batch_no };
          this.$refs.addChild.setBatchData(data);
          this.addModal = true;
          this.resetFlag = !this.resetFlag;
        }
      });
    },
    showEditModal(params) {
      var data = {};
      getBatchInfo(this.batchId).then((res) => {
        if (res.data.code == 200) {
          data = { id: this.batchId, no: res.data.data.batch_no };
          this.$refs.editChild.setBatchData(data);
          getPieceInfo(params.row.id).then((res) => {
            if (res.data.code == 200) {
              this.$refs.editChild.setEditData(res.data.data);
              this.editModal = true;
            }
          });
        }
      });
    },
    addSumit(formValidate) {
      addPiece(formValidate)
        .then((res) => {
          // res
          // data {code data msg}
          // status
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.handleSearch();
            this.addModal = false;
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    editSumit(formValidate) {
      editPiece(formValidate)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.editModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    downloadLink(params) {
      downloadQr(this.batchId, params.row.id).then((res) => {
        if (res.data.code == 200) {
          window.open(res.data.data);
        }
      });
    },
    viewReport(params) {
      window.open(params.row.url);
    },
    cancel() {},
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    handleSearch() {
      this.setTableLoading(true);
      getPieceList(
        this.page,
        this.pageSize,
        this.searchValue,
        this.batchId
      ).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });
    },
    deletePieces() {
      if (this.selectId.length == 0) {
        this.$Message.warning("请选择布匹");
        return;
      }
      this.$Modal.confirm({
        title: "提示",
        content: "<p>是否确认删除？</p>",
        onOk: () => {
          let data = new FormData();
          data.append("ids", this.selectId);
          delPieces(data)
            .then((res) => {
              if (res.data.code == 200) {
                this.handleSearch();
                this.$Message.success("成功!");
              } else {
                this.$Message.error(res.data.msg);
              }
            })
            .catch((err) => {
              this.$Message.error("失败!");
            });
        },
        onCancel: () => {
          this.$Message.info("已取消");
        },
      });
    },
    handleDelete(params) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>是否确认删除？</p>",
        onOk: () => {
          delPiece(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.tableData.splice(params.index, 1);
                this.$Message.success("成功!");
              } else {
                this.$Message.error(res.data.msg);
              }
            })
            .catch((err) => {
              this.$Message.error("失败!");
            });
        },
        onCancel: () => {
          this.$Message.info("已取消");
        },
      });
      // params
      // row
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },
  },
  mounted() {
    this.batchId = this.$route.query.id;
    if (this.batchId == undefined) {
      this.batchId = 0;
    }
    this.getBatchDetail();
    this.handleSearch();
  },
};
</script>
